import { render, staticRenderFns } from "./DisplayAssignedModuleMediationElement.vue?vue&type=template&id=27d095c7&scoped=true&"
import script from "./DisplayAssignedModuleMediationElement.vue?vue&type=script&lang=ts&"
export * from "./DisplayAssignedModuleMediationElement.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayAssignedModuleMediationElement.vue?vue&type=style&index=0&id=27d095c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d095c7",
  null
  
)

/* custom blocks */
import block0 from "./DisplayAssignedModuleMediationElement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDialog,VIcon,VProgressCircular,VRow,VSheet})
